<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="dialogVisible = true">新增包装模板</el-button>
    </div>
    <el-card shadow="never">
      <el-table :data="tableData">
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column prop="name" label="包装名称" width="100" />
        <el-table-column prop="imageUrl" label="图片" width="130">
          <template #default="scope">
            <el-image :src="scope.row.imageUrl" style="width: 100px;height: 100px;" fit="contain"
              :preview-src-list="[scope.row.imageUrl]" />
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格" />
        <el-table-column prop="dosageForm" label="适应剂型" />
        <el-table-column prop="packageType" label="包装类型" />
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button type="text" size="small" @click="editItem(scope.row)" style="margin-right: 10px;">编辑</el-button>
            <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.id)">
              <template #reference>
                <el-button type="text" size="small">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="search.current" :page-size="search.size" layout="total, sizes, prev, pager, next"
        :total="totalNum" background />
    </el-card>

    <!-- 新增品牌 -->
    <el-dialog :visible.sync="dialogVisible" :title="form.id ? '编辑包装模版' : '添加包装模版'" width="500px"
      :close-on-click-modal="false">
      <el-form :model="form" label-width="90px" label-position="right" :rules="rules" ref="ruleForm">
        <el-form-item label="包装名称:" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="包装图片:" prop="imageUrl">
          <upload-cover v-model="form.imageUrl" :limit="1" />
        </el-form-item>
        <el-form-item label="包装类型:" prop="packageType">
          <el-select v-model="form.packageType" placeholder="请选择包装类型" style="width: 100%;" @change="changePackageType">
            <el-option :label="pItem" :value="pItem" v-for="(pItem, pIndex) in packTypeList" :key="pIndex" />
          </el-select>
        </el-form-item>
        <el-form-item label="规格:" prop="specification">
          <el-input v-model="form.specification" />
        </el-form-item>
        <el-form-item label="适应剂型:" prop="dosageForm">
          <el-select v-model="form.dosageForm" multiple placeholder="请选择适应剂型" style="width: 100%;">
            <el-option :label="sItem" :value="sItem" v-for="(sItem, sIndex) in packSolutionList" :key="sIndex" />
          </el-select>
        </el-form-item>
        <el-form-item label="提示词:" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="4" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm()">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>


<script>
import uploadCover from '@/components/upload-cover/upload-cover.vue'
export default {
  components: {
    uploadCover
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.form = {
          packageType: "",
          dosageForm: [],
        }
        this.$refs.ruleForm.resetFields()
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      totalNum: 0,
      tableData: [],
      search: {
        current: 1,
        size: 20
      },
      form: {
        packageType: "", //包装类型（如：玻璃瓶）
        dosageForm: [], //适应剂型
      },
      packTypeList: [],
      packSolutionList: [],
      rules: {
        name: [{ required: true, message: '请输入包装名称', trigger: 'blur' }],
        imageUrl: [{ required: true, message: '请上传图片', trigger: 'change' }],
        packageType: [{ required: true, message: '请选择包装类型', trigger: 'change' }],
        specification: [{ required: true, message: '请输入规格', trigger: 'blur' }],
        dosageForm: [{ required: true, message: '请选择适应剂型', trigger: 'change' }],
        description: [{ required: true, message: '请输入提示词', trigger: 'blur' }],
      }
    }
  },
  created() {
    this.getList()
    this.getPackTypeList()
  },
  methods: {
    // 获取包装类型列表
    async getPackTypeList() {
      const res = await this.$request.get("/cms/pack_customization/get_pack_type")
      if (res.data.code == 200) {
        this.packTypeList = res.data.data
      }
    },
    // 获取药剂类型列表
    async getPackSolutionList() {
      if (!this.form.packageType) {
        return
      }
      const res = await this.$request.get("/cms/pack_customization/get_pack_solution?packType=" + this.form.packageType)
      if (res.data.code == 200) {
        this.packSolutionList = res.data.data
      }
    },
    async getList() {
      const res = await this.$request.post("/cms/pack_customization/get_pack_template_list", this.search)
      if (res.data.code == 200) {
        this.tableData = res.data.data.records
        this.totalNum = res.data.data.total
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.search.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.search.current = val
      this.getList()
    },
    async deleteItem(id) {
      const res = await this.$request.get("/cms/pack_customization/delete_pack_template?packId=" + id)
      if (res.data.code == 200) {
        this.$message.success("删除成功")
        this.getList()
      }
    },
    editItem(row) {
      this.form = this.$deepClone(row)
      this.getPackSolutionList()
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.saveItem()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async saveItem() {
      const res = await this.$request.post(this.form.id ? "/cms/pack_customization/update_pack_template" : "/cms/pack_customization/add_pack_template", this.form)
      if (res.data.code == 200) {
        this.$message.success("操作成功")
        this.dialogVisible = false
        this.getList()
      }
    },
    changePackageType(value) {
      console.log("changePackageType", value)
      this.form.dosageForm = []
      this.getPackSolutionList()
    }
  }
}
</script>